import "../../../../../lib/assets/javascripts/assert.js";

// Private to this module. Each FormFieldInheritanceChain manages a Map of these.
class Field {
  constructor(fieldSelector) {
    this.inherits = this.inherits.bind(this);
    this.format = this.format.bind(this);
    this.updatePlaceholder = this.updatePlaceholder.bind(this);
    this.updateValue = this.updateValue.bind(this);
    this.inheritProp = this.inheritProp.bind(this);
    this.formatProp = this.formatProp.bind(this);
    this.setProp = this.setProp.bind(this);
    this.triggerEventsIfChanged = this.triggerEventsIfChanged.bind(this);
    this.isSelfTriggered = this.isSelfTriggered.bind(this);
    this.asserter = new Asserter();
    this.el = this.asserter.element(fieldSelector);

    this.chain = [];
  }

  // DSL

  inherits(inheritsFrom, sourceProperties, inheritanceFormatter) {
    // Inherit and format if the source field changes
    this.chain.push({ inheritsFrom, sourceProperties, inheritanceFormatter });
    this.asserter.element(inheritsFrom).on("change", this.updatePlaceholder);
    this.updatePlaceholder();

    return this;
  }

  format(formatter) {
    // Format the field if changed directly by the user
    this.formatter = formatter;
    jQuery(this.el).on("change", (event, details) => {
      if (this.isSelfTriggered(event, details)) {
        return;
      }
      return this.updateValue();
    });

    this.updateValue();
    this.updatePlaceholder();
    return this;
  }

  // HELPER FUNCTIONS

  updatePlaceholder() {
    return this.triggerEventsIfChanged("placeholder", () => {
      jQuery.each(this.chain, (_, inheritance) => {
        const { inheritsFrom, sourceProperties, inheritanceFormatter } = inheritance;
        return this.inheritProp("placeholder", inheritsFrom, sourceProperties, inheritanceFormatter);
      });

      return this.formatProp("placeholder", this.formatter);
    });
  }

  updateValue() {
    return this.triggerEventsIfChanged("value", () => this.formatProp("value", this.formatter));
  }

  inheritProp(targetProp, inheritsFrom, sourceProps, formatter) {
    let value = this.getInheritedValue(inheritsFrom, sourceProps);
    if (formatter != null) {
      value = formatter(value);
    }
    return this.setProp(targetProp, value);
  }

  formatProp(targetProp, formatter) {
    if (!formatter) {
      return;
    }
    const formattedValue = formatter(this.el.prop(targetProp));
    return this.setProp(targetProp, formattedValue);
  }

  setProp(targetProp, value = "") {
    return this.el.prop(targetProp, value);
  }

  getInheritedValue(inheritsFrom, sourceProps) {
    const source = jQuery(inheritsFrom);
    if (!jQuery.isArray(sourceProps)) {
      sourceProps = [sourceProps];
    }
    let value = null;

    jQuery.each(sourceProps, function () {
      value = source.prop(this);
      return !jQuery.trim(value);
    }); // Stop if we find a value

    return value;
  }

  triggerEventsIfChanged(prop, fn) {
    const value = this.el.prop(prop);
    fn();
    if (value !== this.el.prop(prop)) {
      this.trigger("inherit");
      this.trigger("change");
      return this.trigger("input");
    }
  }

  trigger(eventName) {
    return this.el.triggerHandler(eventName, [{ triggeredByInheritanceChain: true }]);
  }

  isSelfTriggered(event, details) {
    return details && details.triggeredByInheritanceChain && this.el.is(event.target);
  }
}

window.FormFieldInheritanceChain = class FormFieldInheritanceChain {
  constructor() {
    this.field = this.field.bind(this);
    this.fields = new Map();
    this.asserter = new Asserter();
  }

  field(selector) {
    const element = this.asserter.element(selector)[0];
    if (!this.fields.has(element)) {
      this.fields.set(element, new Field(selector));
    }

    return this.fields.get(element);
  }
};
